// Chatrooms.jsx
/* FIXME: [Chatrooms] issue - in the chat list. sometimes can't fetch next page when the scroll down. (Safari / PWA)
 */
'use strict';
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import SwipeableViews from 'react-swipeable-views';
import { virtualize } from 'react-swipeable-views-utils';

import { SanitizedLink as Link } from '../component/SanitizedLink.jsx';
import {
  InfiniteScroller,
  ScrollItem,
} from '../component/InfiniteScroller.jsx';
import WithIntersectionObserver from '../component/WithIntersectionObserver.jsx';
import Tabs from '../component/Tabs.jsx';
import Tab from '../component/Tab.jsx';

import PullToRefresh from '../container/PullToRefresh.js';
import ChatroomItem from '../container/ChatroomItem.js';
import AutoChatChatroomItem from '../container/AutoChatChatroomItem.js';
import UserCategory from '../container/UserCategory.js';
import GridDiscoverUsers from '../container/GridDiscoverUsers.js';

import Spinning from '../style/Spinning.js';
import {
  breakpoint,
  color,
  textColor,
  footerNavigationHeight,
  iPhoneXSeriesFooterPaddingInPWA,
} from '../style/variables.js';
import ResetButtonStyle from '../style/ResetButtonStyle.js';
import media from '../style/media.js';

import LoadingImage from '../../img/loading.png';
import ChatroomAddIcon from '../../img/ic_add_msg.svg';
import ShopIconSource from '../../img/ic_diamond_shop.svg';
import {
  chatroomListType,
  DESKTOP_TOP_MARGIN_OFFSET,
  DESKTOP_CHATROOMS_WIDTH,
} from '../resource/chatroomConstants.js';
import { getIsIphoneXSeriesPWA } from '../resource/getUserAgent.js';
import { notificationList } from '../resource/notificationConstants.js';
import { CHAT_ID as AUTO_CHAT_CHAT_ID } from '../resource/autoChatConstants.js';
import { ButtonId } from '../resource/trackingConstants.js';
import { TranslationNamespace } from '../resource/translationNamespace.js';

import { headerHeight } from '../style/variables.js';

const VirtualizeSwipeableViews = virtualize(SwipeableViews);
const CHATROOM_TABS = [
  chatroomListType.ALL,
  chatroomListType.UNREAD,
  chatroomListType.PIN,
];

class Chatrooms extends React.Component {
  state = {
    itemIds: [],
  };
  nextTickFetchData = null;
  nextTickSetState = null;
  componentDidMount() {
    this.nextTickFetchData = setTimeout(() => {
      const { itemIds } = this.props;
      this.fetchMeNotifications({
        page: 1,
        listType: notificationList.AUTO_CHAT,
      });
      this.fetchChatrooms({ page: 1 });
      this.setState({ itemIds }, () => {
        this.restoreScrollTop();
      });
    }, 0);
  }
  shouldComponentUpdate(nextProps) {
    const { scrollTop } = this.props;
    if (scrollTop !== nextProps.scrollTop) {
      return false;
    }
    return true;
  }
  componentDidUpdate(prevProps) {
    const { itemIds, configurations, listType, apiCacheTimestamp, isAuthed } =
      this.props;
    const {
      itemIds: prevItemIds,
      listType: prevListType,
      apiCacheTimestamp: prevApiCacheTimestamp,
      isAuthed: prevIsAuthed,
    } = prevProps;
    if (isAuthed && isAuthed !== prevIsAuthed) {
      this.nextTickFetchData = setTimeout(() => {
        this.fetchMeNotifications({
          page: 1,
          listType: notificationList.AUTO_CHAT,
        });
        this.fetchChatrooms({ page: 1 });
      });
    }
    if (listType !== prevListType) {
      this.nextTickFetchData = setTimeout(() => {
        this.fetchChatrooms({ page: 1 });
      });
    }
    if (itemIds !== prevItemIds) {
      this.nextTickSetState && clearTimeout(this.nextTickSetState);
      this.nextTickSetState = setTimeout(() => this.setState({ itemIds }), 0);
    }
    if (apiCacheTimestamp !== prevApiCacheTimestamp) {
      this.nextTick = setTimeout(() => {
        this.fetchChatrooms({ page: 1 });
      });
    }
    if (configurations !== prevProps.configurations) {
      this.fetchMeNotifications({
        page: 1,
        listType: notificationList.AUTO_CHAT,
      });
    }
  }

  componentWillUnmount() {
    this.nextTickSetState && clearTimeout(this.nextTickSetState);
    this.nextTickFetchData && clearTimeout(this.nextTickFetchData);
  }

  fetchMeNotifications = ({ page, listType }) => {
    const { fetchMeNotifications } = this.props;
    fetchMeNotifications({ page, listType });
  };

  fetchChatrooms = ({ page = 1 }) => {
    const {
      fetchChatrooms,
      fetchUnreadChatrooms,
      fetchPinnedChatrooms,
      listType,
    } = this.props;
    if (listType === chatroomListType.ALL) {
      fetchChatrooms({ page });
    } else if (listType === chatroomListType.UNREAD) {
      fetchUnreadChatrooms({ page });
    } else {
      fetchPinnedChatrooms({
        page,
        listType: chatroomListType.PIN,
      });
    }
  };

  restoreScrollTop = () => {
    const { itemIds, currentRoute, previousRoute, scrollTop } = this.props;
    const isPreviousRouteOnChat = /\/chat\/[a-z\d]+/i.test(previousRoute);
    const isOnRoute = currentRoute && currentRoute.includes('/chat');
    if (isOnRoute && isPreviousRouteOnChat && itemIds?.length) {
      setTimeout(() => {
        window.scrollTo(0, scrollTop);
      }, 0);
    }
  };

  handleRefresh = async () => {
    this.fetchMeNotifications({
      page: 1,
      listType: notificationList.AUTO_CHAT,
    });
    this.fetchChatrooms({ page: 1 });
  };

  getShouldShowAutoChat = () => {
    const { listType, hasAutoChat, hasUnreadAutoChat } = this.props;
    return chatroomListType.ALL === listType
      ? hasAutoChat
      : chatroomListType.UNREAD === listType
        ? hasUnreadAutoChat
        : false;
  };

  shouldShowActiveNewChatroom = () => {
    const { isOnDesktop, activeId, listType } = this.props;
    const { itemIds } = this.state;
    return (
      isOnDesktop &&
      activeId &&
      !itemIds.includes(activeId) &&
      listType === chatroomListType.ALL
    );
  };

  renderChatroomItem = id => {
    const { activeId } = this.props;
    return (
      <IntersectionObserverWrapper key={id}>
        <WithIntersectionObserver>
          {({ isIntersecting }) => (
            <ChatroomItemWrapper>
              {id === AUTO_CHAT_CHAT_ID ? (
                <AutoChatChatroomItem
                  id={AUTO_CHAT_CHAT_ID}
                  isIntersecting={isIntersecting}
                />
              ) : (
                <ChatroomItem
                  id={id}
                  isIntersecting={isIntersecting}
                  isActive={activeId === id}
                />
              )}
            </ChatroomItemWrapper>
          )}
        </WithIntersectionObserver>
      </IntersectionObserverWrapper>
    );
  };

  renderEmpty({ key }) {
    const { t, listType, searchSwaggerOnlineFeed, isOnDesktop } = this.props;
    return (
      <div key={key}>
        <Placeholder>
          <PlaceholderText>
            {listType === chatroomListType.ALL &&
              t('chat_empty_message', {
                ns: TranslationNamespace.CHAT,
              })}
            {listType === chatroomListType.UNREAD &&
              t('chatlist_no_new_messages', {
                ns: TranslationNamespace.CHAT,
              })}
            {listType === chatroomListType.PIN &&
              t('no_pin_chatroom', {
                ns: TranslationNamespace.CHAT,
              })}
          </PlaceholderText>
        </Placeholder>
        {!isOnDesktop && (
          <GridDiscoverUsers
            category={searchSwaggerOnlineFeed}
            withChatLink
            size={104}
            marginTop={12}
          />
        )}
      </div>
    );
  }

  renderContent({ key }) {
    const { itemIds } = this.state;
    const {
      activeId,
      nextPage,
      isNextPageFetching,
      itemIds: propsItemIds,
      setScrollerPositionData,
    } = this.props;
    const isLengthDifferent = itemIds.length !== propsItemIds.length;

    return (
      <InfiniteScroller
        key={key}
        pageStart={1}
        hasMore={nextPage != null}
        loadMore={() => this.fetchChatrooms({ page: nextPage })}
        isFetching={isNextPageFetching || isLengthDifferent}
        threshold={100}
        recordPosition={scrollerPositionData =>
          setScrollerPositionData({
            scrollerPositionData,
            page: 'chatrooms',
          })
        }
      >
        <ChatroomsList>
          <ScrollItem
            loader={
              <Loader>
                <img src={LoadingImage} />
              </Loader>
            }
          >
            {this.getShouldShowAutoChat() &&
              this.renderChatroomItem(AUTO_CHAT_CHAT_ID)}
            {this.shouldShowActiveNewChatroom() &&
              this.renderChatroomItem(activeId)}
            {itemIds.map(this.renderChatroomItem)}
          </ScrollItem>
        </ChatroomsList>
      </InfiniteScroller>
    );
  }

  renderTabs = () => {
    const { t, listType, setChatroomTab } = this.props;
    return (
      <ChatTabs>
        <Tabs
          value={listType}
          onChange={(_, listType) => {
            setChatroomTab({
              listType,
            });
          }}
          style={{
            width: '100%',
          }}
        >
          <Tab
            as="button"
            value={chatroomListType.ALL}
            label={t('chatlist_all_messages', {
              ns: TranslationNamespace.CHAT,
            })}
          />
          <Tab
            as="button"
            value={chatroomListType.UNREAD}
            label={t('chatlist_all_unread', {
              ns: TranslationNamespace.CHAT,
            })}
          />
          <Tab
            as="button"
            value={chatroomListType.PIN}
            label={t('pin', {
              ns: TranslationNamespace.CHAT,
            })}
          />
        </Tabs>
      </ChatTabs>
    );
  };

  scrollToTop = () => window.scrollTo({ top: 0, behavior: 'smooth' });

  render() {
    const {
      itemIds,
      isFirstPageFetched,
      nextPage,
      isFirstPageFetching,
      isAuthed,
      isDiamondShopOpen,
      isOnDesktop,
      hasChatrooms,
      deviceHeight,
      listType,
      setChatroomTab,
      searchSwaggerOnlineFeed,
      t,
      addvalue,
    } = this.props;
    const isLoading =
      isAuthed && itemIds.length === 0 && !nextPage && isFirstPageFetching;
    const isEmpty =
      !isAuthed ||
      (itemIds.length === 0 &&
        isFirstPageFetched &&
        !this.getShouldShowAutoChat());
    const shouldShowUserList =
      (isOnDesktop && hasChatrooms) || (!isOnDesktop && !isEmpty);

    return (
      <StyledChatrooms
        isIphoneXSeriesPWA={getIsIphoneXSeriesPWA()}
        deviceHeight={deviceHeight}
      >
        <Header>
          <HeaderLeft>
            <HeaderTitle onClick={this.scrollToTop}>
              {t('chatroom_list_title', {
                ns: TranslationNamespace.CHAT,
              })}
            </HeaderTitle>
          </HeaderLeft>
          <HeaderRight>
            <NewChatroomIcon
              as={Link}
              to="/chat/start"
              title={t('swagr_create_chatroom', {
                ns: TranslationNamespace.CHAT,
              })}
              data-element_id={ButtonId.Chatroom.ButtonNewChatroom}
            >
              <img
                src={ChatroomAddIcon}
                alt={t('swagr_create_chatroom', {
                  ns: TranslationNamespace.CHAT,
                })}
              />
            </NewChatroomIcon>
            <ShopButton
              isMatch={isDiamondShopOpen}
              title={t('buy_points', {
                ns: TranslationNamespace.GENERAL,
              })}
              data-element_id={ButtonId.All.ButtonDiamondShop}
              onClick={addvalue}
            >
              <img
                src={ShopIconSource}
                alt={t('buy_points', {
                  ns: TranslationNamespace.CHAT,
                })}
              />
            </ShopButton>
          </HeaderRight>
          {this.renderTabs()}
        </Header>
        {isLoading ? (
          <Loader>
            <img src={LoadingImage} />
          </Loader>
        ) : (
          <>
            {shouldShowUserList && (
              <UserCategory
                category={searchSwaggerOnlineFeed}
                shouldDisplayHeader={false}
                avatarSize={64}
                style={{
                  backgroundColor: `${color.black}`,
                  paddingTop: '14px',
                  height: '144px',
                }}
                withChatLink
                usernameMarginTop={6}
                marginRight={0}
              />
            )}
            <PullToRefresh useWindow onRefresh={this.handleRefresh}>
              <Body>
                <VirtualizeSwipeableViews
                  index={CHATROOM_TABS.indexOf(listType)}
                  onChangeIndex={sliderIndex => {
                    const newListType = CHATROOM_TABS[sliderIndex];
                    setChatroomTab({ listType: newListType });
                  }}
                  slideCount={CHATROOM_TABS.length}
                  slideRenderer={({ key }) =>
                    isEmpty
                      ? this.renderEmpty({ key })
                      : this.renderContent({ key })
                  }
                />
              </Body>
            </PullToRefresh>
          </>
        )}
      </StyledChatrooms>
    );
  }
}

Chatrooms.propTypes = {
  itemIds: PropTypes.arrayOf(PropTypes.string),
  configurations: PropTypes.array,
  nextPage: PropTypes.number,
  isNextPageFetching: PropTypes.bool,
  isAuthed: PropTypes.bool,
  isDiamondShopOpen: PropTypes.bool,
  fetchChatrooms: PropTypes.func,
  fetchPinnedChatrooms: PropTypes.func,
  isFirstPageFetching: PropTypes.bool,
  isFirstPageFetched: PropTypes.bool,
  hasAutoChat: PropTypes.bool,
  hasUnreadAutoChat: PropTypes.bool,
  isOnDesktop: PropTypes.bool,
  hasChatrooms: PropTypes.bool,
  t: PropTypes.func.isRequired,
  scrollTop: PropTypes.number,
  deviceHeight: PropTypes.number,
  previousRoute: PropTypes.string,
  currentRoute: PropTypes.string,
  setScrollerPositionData: PropTypes.func,
  listType: PropTypes.string,
  activeId: PropTypes.string,
  setChatroomTab: PropTypes.func,
  fetchUnreadChatrooms: PropTypes.func,
  addvalue: PropTypes.func,
  fetchMeNotifications: PropTypes.func,
  apiCacheTimestamp: PropTypes.number,
  searchSwaggerOnlineFeed: PropTypes.string,
};

Chatrooms.defaultProps = {
  itemIds: [],
  configurations: [],
  isDiamondShopOpen: false,
  isFirstPageFetched: false,
  isFirstPageFetching: false,
  hasAutoChat: false,
  hasUnreadAutoChat: false,
  isAuthed: false,
  isOnDesktop: false,
  hasChatrooms: false,
  fetchChatrooms: () => null,
  fetchPinnedChatrooms: () => null,
  scrollTop: 0,
  deviceHeight: 0,
  previousRoute: '',
  currentRoute: '',
  activeId: '',
  setScrollerPositionData: () => null,
  listType: chatroomListType.ALL,
  setChatroomTab: () => null,
  fetchUnreadChatrooms: () => null,
  fetchMeNotifications: () => null,
  addvalue: () => null,
  apiCacheTimestamp: 0,
  searchSwaggerOnlineFeed: null,
};

const StyledChatrooms = styled.div`
  --space-to-styled-chatroom-top: 108px;
  height: ${({ deviceHeight }) =>
    `calc(${deviceHeight}px - ${headerHeight}px - var(--space-to-pinned-notification))`};
  overflow-y: auto;
  padding-top: var(--space-to-styled-chatroom-top);
  padding-bottom: 0;
  @media (max-width: ${breakpoint.mobile}px) {
    height: auto;
    overflow-y: hidden;
    padding-top: calc(
      var(--space-to-styled-chatroom-top) + var(--space-to-pinned-notification)
    );
    padding-bottom: ${({ isIphoneXSeriesPWA }) =>
      (isIphoneXSeriesPWA ? iPhoneXSeriesFooterPaddingInPWA : 0) +
      footerNavigationHeight}px;
  }
  ::-webkit-scrollbar {
    display: none;
  }
`;

const Header = styled.div`
  flex: none;
  position: fixed;
  top: ${DESKTOP_TOP_MARGIN_OFFSET}px;
  width: ${DESKTOP_CHATROOMS_WIDTH}px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${headerHeight}px;
  z-index: 3;
  background-color: ${color.black};
  @media (max-width: ${breakpoint.tablet}px) {
    top: calc(
      ${DESKTOP_TOP_MARGIN_OFFSET}px + var(--space-to-pinned-notification)
    );
  }
  @media (max-width: ${breakpoint.mobile}px) {
    top: var(--space-to-pinned-notification);
    width: 100%;
  }
`;

const HeaderSection = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  transform: translateY(-50%);
  display: flex;
  align-items: center;
`;
const HeaderLeft = styled(HeaderSection)`
  top: 50%;
  left: 16px;
`;

const HeaderRight = styled(HeaderSection)`
  top: 50%;
  right: 16px;
  font-size: 12px;
`;

const HeaderTitle = styled.button`
  ${ResetButtonStyle};
  color: ${textColor.white};
  font-size: 22px;
  font-weight: 600;
`;

const Body = styled.div`
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
`;

const Icon = styled.button`
  ${ResetButtonStyle};
  position: relative;
  flex: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  transition: 0.3s;
  background-color: ${({ isMatch }) =>
    isMatch ? 'rgba(0, 126, 114, 0.2)' : 'transparent'};
  opacity: 1;
  & + & {
    margin-left: 8px;
  }
  > img {
    width: 28px;
    height: 28px;
    object-fit: contain;
  }
  @media (hover: hover) {
    :hover {
      background-color: rgba(155, 155, 155, 0.2);
      opacity: 1;
    }
  }
  ${media.mobile`
    & + & {
      margin-left: 4px;
    }
  `};
`;

const ShopButton = styled(Icon)``;
const NewChatroomIcon = styled(Icon)``;

const Placeholder = styled.div`
  flex: auto;
  margin-top: 20px;
  margin-bottom: 28px;
`;

const PlaceholderText = styled.div`
  color: #646464;
  font-size: 14px;
  text-align: center;
`;

const ChatroomsList = styled.div`
  flex: auto;
`;

const Loader = styled.div`
  text-align: center;
  padding: 8px 0;
  margin-top: 32px;
  width: 100%;
  & > img {
    width: 32px;
    animation: 3s infinite ${Spinning};
  }
`;

const IntersectionObserverWrapper = styled.div``;

const ChatroomItemWrapper = styled.div``;

const ChatTabs = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  height: 39px;
  top: calc(
    ${DESKTOP_TOP_MARGIN_OFFSET}px + ${headerHeight}px +
      var(--space-to-pinned-notification)
  );
  width: ${DESKTOP_CHATROOMS_WIDTH}px;
  display: flex;
  align-items: center;
  cursor: pointer;
  border-bottom: 1px solid rgba(100, 100, 100, 0.15);
  background-color: ${color.black};

  @media (max-width: ${breakpoint.mobile}px) {
    top: calc(var(--space-to-pinned-notification) + ${headerHeight}px);
    width: 100%;
  }
`;

export default withTranslation()(Chatrooms);
